<h1 mat-dialog-title style="color: red;">Warning</h1>
<div mat-dialog-content>
	<p>{{data.txt}}</p>
</div>
<div mat-dialog-actions>
	<div class="col-lg-12 text-right">
		<button type="button" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial>
			Cancel
		</button>&nbsp;
		<button type="button" mat-raised-button
			color="primary" (click)="onOk()">
			Proceed
		</button>
	</div>
</div>
